import { createMuiTheme } from '@material-ui/core/styles';

export const drawerWidth = 304;
export const headerHeight = 120;
export const mobileHeaderHeight = 100;
export const footerHeight = 80;

export const grey = {
  light: '#E3ECF6',
  medium: '#CCCCCC',
  dark: '#333333',
  medium2: '#666666',
  medium3: '#999999',
};

export const primary = {
  light: '#FFFFFF',
  main: '#FFFFFF',
  dark: '#FFFFFF',
  contrastText: '#000',
};

export const secondary = {
  light: '#641723',
  main: '#44244D',
  dark: '#381a40',
  contrastText: '#FFF',
};

export default createMuiTheme({
  palette: {
    primary,
    secondary,
  },
  sidebar: {
    width: 200,
  },
  button: {
    root: {
      display: 'none',
    },
  },
  typography: {
    fontFamily: 'sans-serif',
    h1: {
      fontSize: '2rem',
    },
    h2: {
      fontSize: '1.75rem',
    },
    h3: {
      fontSize: '1.5rem',
    },
    h4: {
      fontSize: '1.25rem',
    },
    h5: {
      fontSize: '1.1rem',
    },
    h6: {
      fontSize: '1rem',
    },
  },
  overrides: {
    MuiAppBar: {
      root: {
        padding: [[0, 24]],
        '& a': {
          color: '#fff',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      },
    },
    MuiTableSortLabel: {
      root: {
        '&:hover': {
          color: '#fff',
        },
      },
    },
    MuiButton: {
      root: {
        borderRadius: 0,
      },
      textPrimary: {
        color: primary,
      },
      outlinedSizeSmall: {
        height: '24px',
        fontSize: '12px',
        '&:hover': {
          backgroundColor: secondary,
          border: `1px solid ${secondary}`,
        },
      },
    },
  },
});
